import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiGrowAnimation from '@mui/material/Grow';
import React from 'react';
import { Paper } from '../../paper';
import { styled } from '../../styled';
import { useRubiksTheme } from '../../theme';
const AutocompletePaper = styled(Paper)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius
}));
const PaperComponent = React.forwardRef((props, ref) => {
    const { ThemeProvider } = useRubiksTheme();
    const { value, PopperHeader, popperHeaderProps, menuTheme, elevation: _elevation, ...muiProps } = props;
    const content = (
    // @see https://mui.com/material-ui/transitions/#grow
    // @see https://github.com/mui/material-ui/issues/19262
    // eslint-disable-next-line react/forbid-component-props
    _jsx(MuiGrowAnimation, { in: true, style: { transformOrigin: '100% 0 0' }, children: _jsxs(AutocompletePaper, { elevation: "L", ref: ref, ...muiProps, children: [PopperHeader && (_jsx(PopperHeader, { ...popperHeaderProps, value: value })), props.children] }) }));
    return menuTheme ? (_jsx(ThemeProvider, { theme: menuTheme, children: content })) : (content);
});
export default { PaperComponent };
